import { useCallback, useContext } from 'react';
import { HistoryActionType, HistoryContext } from '@core/context';

export const useHistoryFilterState = () => {
  const { state: historyState, dispatch: historyDispatch } = useContext(HistoryContext);

  const setUserFilter = useCallback(
    (payload: string) => {
      historyDispatch({ type: HistoryActionType.SetUser, payload });
    },
    [historyDispatch]
  );

  const setUsersList = useCallback(
    (payload: string[]) => {
      historyDispatch({ type: HistoryActionType.SetUsersList, payload });
    },
    [historyDispatch]
  );

  return {
    historyState,
    setUserFilter,
    setUsersList,
  };
};
